import styled from 'styled-components'

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 12px;
`
